import type { TableColumnConfig } from '@ipfabric/utils';
import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { saveTableSettings } from './saveTableSettings';

interface ChangeTableColumnVisibilityCommand {
  columnKey: TableColumnConfig['key'];
  value: boolean;
}

export const changeTableColumnVisibility: TableCommandFactory<
  ChangeTableColumnVisibilityCommand
> = (cmdContext, dispatch) => async (command) => {
  cmdContext.updateState((draft) => {
    if (draft.settings.columnVisibility === undefined) {
      draft.settings.columnVisibility = {};
    }
    draft.settings.columnVisibility[command.columnKey] = command.value;
  });

  dispatch(saveTableSettings);
};
